<template>
  <div :class="['vc-container', {mobile: isMobile}]" :style="{'pointer-events': 'none'}">

    <v-scale-transition>
      <v-btn
          style="pointer-events: auto"
          v-show="isMobile ? !fullScreen : minimized"
          fixed bottom left
          @click.stop="isMobile ? fullScreen = true : minimized = false"
          fab
          color="accent"
      >
        <v-badge
            bottom
            dot
            color="primary lighten-3"
            overlap
            offset-x="12"
            offset-y="8"
        >
          <v-icon
              size="35"
          >{{ fullScreen ? 'mdi-arrow-collapse' : 'mdi-video' }}</v-icon>
        </v-badge>
      </v-btn>
    </v-scale-transition>



    <vue-draggable-resizable
        v-show="fullScreen || !minimized"
        style="pointer-events: auto"
        :parent="true"
        :w="w"
        :h="h"
        :min-width="minWidth"
        :min-height="minHeight"
        :x="x"
        :y="y"
        :resizable="resizable"
        :draggable="draggable"
        @dragging="blockPointerEvents = true"
        @dragstop="blockPointerEvents = false"
        @resizing="blockPointerEvents = true"
        @resizestop="blockPointerEvents = false"
    >
      <v-card height="100%" elevation="10" >
        <v-card-title>

          <template v-if="!isMobile || (isMobile && fullScreen)">
            Videollamada
            <v-spacer></v-spacer>
          </template>

          <v-btn icon @click="fullScreen = false ; minimized = true">
            <v-icon>mdi-window-minimize</v-icon>
          </v-btn>

          <v-btn icon v-show="!isMobile" @click="fullScreen = !fullScreen">
            <v-icon>{{fullScreen ? 'mdi-window-restore' : 'mdi-window-maximize'}}</v-icon>
          </v-btn>

        </v-card-title>

        <v-card-text class="fill-height" >
          <kim-meet-client
              v-if="!!currentEvent"
              :style="{'pointer-events': blockPointerEvents ? 'none' : 'inherit', height: '80%'}"
              performance-mode
              :user="{displayName: currentUser && currentUser.first_name || 'Usuario Kyra'}"
              :room-id="currentEvent.vc_id"
              width="100%"
              height="100%"
              :controls="['camera', 'microphone', 'chat', 'desktop', 'fullscreen', 'settings', 'tileview']"
          />
        </v-card-text>
      </v-card>
    </vue-draggable-resizable>
  </div>

</template>

<script>

    import {mapState} from 'vuex'
    import {getLabel} from '@/utils/Institution'

    import Vue from 'vue'
    import VueDraggableResizable from 'vue-draggable-resizable'
    import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

    Vue.component('vue-draggable-resizable', VueDraggableResizable)

    const DesktopHeight = 300
    const DesktopWidth = 350
    const DesktopMargin = 20

    const MobileHeight = 300
    const MobileWidth = 300
    const MobileMargin = 10
    const TopBarMargin = 55

    export default{
        components: {
            KimMeetClient: () => import('@/components/common/webRTC/KimMeetClient'),
        },
        data(){
            return {
              blockPointerEvents: false,
              minimized: false,
              fullScreen: false,
              windowSize: {
                width: 0,
                height: 0
              }
            }
        },
        mounted(){
          this.onResize()
          window.addEventListener('resize', this.onResize, { passive: true })
        },
        beforeDestroy () {
          if (typeof window === 'undefined') return
          window.removeEventListener('resize', this.onResize)
        },
        methods: {
          onResize(){
            this.windowSize = { width: window.innerWidth, height: window.innerHeight }
          }
        },
        computed:{
          ...mapState('clientAttention', {
            currentEvent: state => state.currentEvent,
            drawer: state => state.attentionSummaryDrawer

          }),
          ...mapState(['currentUser']),
          waitingForGuestLabel() {
            return `Esperando al ${getLabel('commons.client.singular').toLowerCase()}...`
          },
          minWidth(){
            const vm = this
            return MobileWidth;
          },
          minHeight(){
            const vm = this
            return MobileHeight;
          },
          w(){
            const vm = this
            if(vm.isMobile){
              return vm.fullScreen ?
                  vm.windowSize.width : MobileWidth
            }

            return vm.fullScreen ?
                vm.windowSize.width - DesktopMargin : DesktopWidth

          },
          h(){
            const vm = this
            if(vm.isMobile){
              return  vm.fullScreen ?
                  vm.windowSize.height: MobileHeight
            }

            return vm.fullScreen ?
                vm.windowSize.height: DesktopHeight
          },
          x(){
            const vm = this
            if(vm.isMobile){
              return vm.fullScreen ? 0 : MobileMargin
            }

            return vm.fullScreen ? 0 : DesktopMargin
          },
          y(){
            const vm = this
            const margin = vm.isMobile ? MobileMargin : DesktopMargin
            if (vm.isMobile){
              return  vm.fullScreen ?  vm.windowSize.height - vm.h - margin : TopBarMargin
            }

            return vm.fullScreen ? 0
                : vm.windowSize.height - vm.h - margin
          },
          draggable() {
            return !this.fullScreen
          },
          resizable() {
            return !this.fullScreen
          }
        },
        beforeRouteLeave(to, from, next){

            next()
        },
        watch:{
            isMobile(val){
              const vm = this
              if(val) {
                vm.minimized = true
                vm.fullScreen = false
              }
            },
            currentEvent(val){
                var vm = this
                if(!val || !val.event_status) return

                if(val.event_status.id === 4){
                    //vm.$refs.videoChatClient.join()
                }
            }
        }
    }
</script>

<style scoped>
  >>>.v-badge--dot .v-badge__badge{
    height: 10px;
    width: 10px;
    animation: recording 1s ease-in-out infinite;
    box-shadow: 1px 1px 6px var(--v-accent-base);
  }

    .vc-container{
      z-index: 10;
      left:0;
      top: 0;
      height: 100%;
      width: 100%;
      position: fixed;
    }

    .vc-container.mobile{
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }

    .minimized{
      position: absolute;
      left: 10px;
      bottom: 15px;
      background-color: transparent;
    }

    @keyframes recording {
      0% {
        opacity: 0;
      }

      30%{
        opacity: 100%;
      }

      70%{
        opacity: 100%;
      }

      100%{
        opacity: 0;
      }

    }

</style>
